
import { Component, Vue, Prop } from 'vue-property-decorator';
import { createPopper } from '@popperjs/core';
import type { Instance, VirtualElement, StrictModifiers } from '@popperjs/core';
import { Placement } from '@popperjs/core/lib/enums';

@Component
export default class Tooltip extends Vue {
  @Prop({ type: String, required: true }) public text: string;
  @Prop({ type: String, required: false, default: 'text-white' }) public className: string;
  @Prop({ type: String, required: false, default: 'top' }) public direction: Placement;
  @Prop({ type: Number, required: false, default: 500 }) public delay: number;
  @Prop({ type: Number, required: false, default: 100 }) public delayHide: number;
  @Prop({ type: Boolean, required: false, default: false }) public arrow: boolean;

  private popper: Instance;
  public show = false;
  private showTimeout: null | ReturnType<typeof setTimeout> = null;

  public showTooltip() {
    this.showTimeout = setTimeout(() => {
      this.show = true;
      this.popper.update();
    }, this.delay);
  }

  public hideTooltip() {
    if (this.showTimeout) {
      clearTimeout(this.showTimeout);
    }
    setTimeout(() => {
      this.show = false;
    }, this.delayHide);
  }

  private mounted() {
    const reference = this.$refs.reference as Element | VirtualElement;
    const tooltip = this.$refs.tooltip as HTMLElement;
    if (reference && tooltip) {
      this.popper = createPopper<StrictModifiers>(reference, tooltip, {
        placement: this.direction,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 4],
            },
          },
        ],
      });
    }
  }

  private beforeDestroy() {
    this.popper.destroy();
  }
}
